import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-indicator-scheduled",
  "use": "icon-indicator-scheduled-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"icon-indicator-scheduled\"><path fill-rule=\"evenodd\" d=\"M19 8v7c0 .197 0 .541-.046.948.11.148.196.276.257.366l3.92 5.799c.446.659 2.24 3.314-.244 4.994-2.486 1.68-4.28-.975-4.726-1.634l-3.92-5.799c-.282-.416-1.104-1.631-1.041-2.893-.2-.74-.2-1.459-.2-1.781V8c0-.795 0-4 3-4s3 3.205 3 4\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol